module.exports = __webpack_public_path__ + "static/gooddogslogo-32ea4b7c23be0d39cf6a9e5e6ecd1556.png";